import React, { ReactNode, useMemo } from 'react';

import { BadgeName } from 'components/Badges';
import GroupBadges from 'components/Badges/GroupBadges';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { AdminUser } from 'models/adminUser';

import { PreviewIcons } from './ListPreview';
import { Container, Header, ErrorMessage } from './styles';

export interface PreviewItem {
  title: string;
  subtitle?: string;
}

export interface Props {
  placeholder: string;
  title?: string;
  icon: PreviewIcons;
  active?: boolean;
  badgeItems?: AdminUser[];
  rightIcon?: ReactNode;
  errorMessage?: string;
  onClick: () => void;
  onAdd?: () => void;
}

const SimpleCard = ({
  placeholder,
  title,
  icon,
  rightIcon,
  active,
  badgeItems,
  errorMessage,
  onClick,
  onAdd,
}: Props) => {
  const { t } = useStoreTranslation();

  const BADGE_ITEMS: BadgeName[] = useMemo(
    () => (badgeItems ? badgeItems?.map(({ name, lastName }) => ({ name, lastName })) : []),
    [badgeItems],
  );

  return (
    <>
      <Container error={!!errorMessage}>
        <Header onClick={active || !onAdd ? onClick : onAdd}>
          <Header.Icon src={`/images/list-preview-icons/${icon}${!active ? '-disabled' : ''}.svg`} alt="" />
          {active ? (
            <>
              <div>
                <Header.Title>{title}</Header.Title>
                {badgeItems && <GroupBadges itemsBadges={BADGE_ITEMS} />}
              </div>
              <Header.ArrowIcon />
            </>
          ) : (
            <>
              <Header.Placeholder $empty>{placeholder}</Header.Placeholder>
              {rightIcon ? <Header.RightIcon>{rightIcon}</Header.RightIcon> : <Header.ArrowIcon $empty />}
            </>
          )}
        </Header>
      </Container>
      {errorMessage && <ErrorMessage>{t(errorMessage)}</ErrorMessage>}
    </>
  );
};

export default SimpleCard;
